"use client";

import { googleAuthAction } from "@/app/(logged-out)/auth/auth-actions";
import { Button } from "@/components/ui/button";
import { routes } from "@/app/constants";
import { toast } from "@/utils/toast";
import { useTransition } from "react";

export function GoogleAuthButton({ type }: { type: "login" | "signup" }) {
  const [isPending, startTransition] = useTransition();

  const handleGoogleAuth = () => {
    startTransition(async () => {
      const { error } = await googleAuthAction(routes.protectedRoutes.timeline);
      if (error) {
        toast({ type: "error", message: `${error}` });
      }
    });
  };

  return (
    <div className="flex flex-col gap-3">
      <Button variant="outline" className="w-full" onClick={handleGoogleAuth} disabled={isPending}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-5 h-5 mr-2">
          <path
            d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"
            fill="currentColor"
          />
        </svg>
        {isPending
          ? `${type === "login" ? "Logging in" : "Signing up"}...`
          : `${type === "login" ? "Log in" : "Sign up"} with Google`}
      </Button>
    </div>
  );
}
